const PageNotFound = () => {
  return (
    <h4>Page Not Found</h4>
  )
}

export default PageNotFound
